// extracted by mini-css-extract-plugin
module.exports = {"Voting":"Voting_Voting__38_RP","Title":"Voting_Title__2kapM","Choices":"Voting_Choices__276IK","Active":"Voting_Active__2kvF3","VotingWrap":"Voting_VotingWrap__3AkQ1"};